export default __webpack_public_path__ + "static/media/Prosperity Life.3390da06.svg";